import { createAction } from '@reduxjs/toolkit';

export const requestCreateTribeTemplate = createAction('request/createTribeTemplate');
export const requestViewTribeTemplate = createAction('request/ViewTribeTemplate');
export const requestUpdateTribeTemplate = createAction('request/UpdateTribeTemplate');
